//PAQUETERIAS

import { useEffect, useState, useMemo, useRef } from "react";
import { CustomDialog, Confirm } from "react-st-modal";
import { Box } from "@mui/material";
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import dayjs from 'dayjs';

import NotificationSystem from "react-notification-system";
//COMPONENTES Y FUNCIONES
import RENDER_TOOLBAR_INTERNAL_ACTIONS from "../../main_components/methods_v2/export";
import CREATE_UPDATE_EXPENSE from "./tools/create_expense";
import MODAL_TABLE from "../../main_components/modal/modal_Table";
import SEARCH_FILTERS from "../../main_components/methods_v2/shearch_filter";
import AlertResponse from "../../main_components/alerts/alertResponse";
import EXPENSE_DETAIL from "./detail_expense/expense_datail_";
import UPDATE_EXPENSE_V2 from "./tools/update_expense";
import { BREADCRUMBS } from "../../main_components/pagination/breadcrumbs";
import { refresh_token } from "../../main_components/tokens/tokenrefresh";
import { expenses_download } from "../../services/expenses/expense";
import { base64toBlobxml, base64toBlob } from "../../main_components/donwloadfuncion/download";
import { date_current } from "../../main_components/date/date";
import { previous_date } from "../../main_components/date/date";
import { expenses_get } from "../../services/expenses/expense";
import { expenses_delete } from "../../services/expenses/expense";
import { findInObjectDisplayRole } from "../../Content/verify_role";
//ESTILOS
//IMAGENES/ICONOS

import PDF from "../../imgComponents/pdf.png"
import DELETE from "../../imgComponents/borrar.png"
import EDIT from "../../imgComponents/save.png"
import CREATE from "../../imgComponents/create.png";



const EXPENSES_V2 = (props) => {
  const [data, setData] = useState([]);
  const [modalT, setmodalT] = useState(false);
  const [ff, setff] = useState(dayjs(date_current));
  const [fi, setfi] = useState(dayjs(previous_date));
  const notificationSystemRef = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const [total_rows, settotal_rows] = useState("");



  function alertas(msj, status) {

    if (status === true) {
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={true}></AlertResponse>,
        level: 'success',
        position: 'br',
        autoDismiss: 10,
      });
    } else {
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={false}></AlertResponse>,
        level: 'error',
        position: 'br',
        autoDismiss: 60,
      });
    }
  }



  const handleDelete = async (id) => {
    setmodalT(true)
    try {
      await expenses_delete(id);
      setmodalT(false)
      handleSubmit()

      alertas("Gasto eliminado correctamente", true);
    } catch (err) {
      console.log("error", err);
      setmodalT(false);
      alertas("Error, no se pudo eliminar el Gasto", false);
    }
  }



  const handleSubmit = async (menssageAlert) => {
    try {
      setIsLoading(true);
      var rf_token = await refresh_token();
      if (rf_token === true) {
        try {
          setmodalT(true);
          console.log(props.expense);
          var dt = await expenses_get(fi.format('YYYY-MM-DD'), ff.format('YYYY-MM-DD'), props.expense);
          setData(
            dt?.data?.sort((a, b) => (a.id < b.id ? 1 : a.id > b.id ? -1 : 0))
          );
          setmodalT(false);
          setIsLoading(false);
          if (menssageAlert === undefined) {
            console.log("sin alerta");
          } else {
            notificationSystemRef.current.addNotification({
              message: (
                <AlertResponse msj={menssageAlert} view={true}></AlertResponse>
              ),
              level: "success",
              position: "br",
              autoDismiss: 10,
            });
          }
        } catch (err) {
          console.log("error", err);
          setData([]);
          setmodalT(false);
          setIsLoading(false);
        }
      } else {
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handle_download_invoice = async (id, file_name, document_type) => {
    setmodalT(true);

    try {
      var data = await expenses_download(id, file_name, document_type);
      setmodalT(false);
      var dt = data.data.file;
      var blob;
      if (document_type === "xml") {
        blob = base64toBlobxml(dt);
        console.log("entra aqui");
      } else {
        blob = base64toBlob(dt);
      }
      const blobUrl = URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      var arr = file_name?.split("/");
      downloadLink.download = arr[4] + `.${document_type}`;
      downloadLink.click();
      setmodalT(false);
    } catch (err) {
      setmodalT(false);
    }
  };


  useEffect(() => {
    handleSubmit();
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "Acciones",
        id: "Actions",
        enableFilters: false,
        enableEditing: false,
        enableRowOrdering: false,
        enableGrouping: false,
        enableColumnDragging: false,
        enableColumnActions: false,
        enableFilterMatchHighlighting: false,
        enableColumnFilterModes: false,
        enableColumnFilter: false,
        size: 120,
        accessorFn: (d) => {
          return (
            <div>
              <img
                alt=""
                src={PDF}
                onClick={() => handle_download_invoice(d.id, d.file_name, "pdf")}
                style={{ cursor: "pointer", margin: "2px", display: findInObjectDisplayRole(["PU:ND1", "PU:ND3"]) }}
              ></img>
              <img alt="" src={EDIT}
                style={{ cursor: "pointer", margin: "2px", display: findInObjectDisplayRole(["PU:ND2", "PU:ND3"]) }}
                onClick={async () => {
                  if (d?.modifiable !== false) {
                    const result = await CustomDialog(
                      <UPDATE_EXPENSE_V2
                        codCocept={d?.concept}
                        codDescripcion={d?.description}
                        codDate={d?.date}
                        codImporte={d?.ammount}
                        codAccount={d?.id_account}
                        codIdPayment={d?.paiement_account}
                        id_expense={d?.id}
                        codidConcept={d?.id_account}
                        foreing={props?.foreing}
                        method={"UPDATE"}
                        id={d?.id}
                        account={d?.account}
                        handle_consult={handleSubmit}
                      ></UPDATE_EXPENSE_V2>,
                      {
                        className: "custom-modal",
                        title: "Editar Gasto",
                        showCloseIcon: true,
                        isCanClose: false,
                      }
                    );

                  } else {
                    alert("Este gasto ya no se puede modificar.");
                  }
                }
                }

              ></img>
              <img alt="" src={DELETE}
                style={{ cursor: "pointer", margin: "2px", display: findInObjectDisplayRole(["PU:GE1", "PU:GE3"]) }}
                onClick={async () => {
                  const result = await Confirm('¿Esta usted seguro de eliminar este Gasto?', 'Eliminar Gasto', 'Si', 'No');
                  if (result) {
                    handleDelete(d.id)
                  }
                }
                }></img>
            </div >
          );
        }
      },
      {
        header: "No.",
        accessorKey: "spend_folio_number",
        size: 100
      },
      {
        header: "Fecha",
        accessorKey: "date",
      },
      {
        header: "Concepto",
        accessorKey: "concept",
      },
      {
        header: "Descripción",
        accessorKey: "description",
        size: 300
      },
      {
        header: "Importe",
        accessorKey: "ammount",
        Cell: ({ cell }) => {
          return (
            <Box
              component="span"
              sx={(theme) => ({
                backgroundColor: theme.palette.success.dark,
                borderRadius: '0.25rem',
                color: '#fff',
                maxWidth: '9ch',
                p: '0.25rem',
              })}
            >
              {cell.getValue() === undefined ? 0?.toLocaleString?.('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) : cell.getValue()?.toLocaleString?.('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Box>
          )
        },
        muiTableBodyCellProps: {
          align: 'right',
        },
        muiTableFooterCellProps: {
          align: 'right',
        },
      },
      {
        header: "Usuario",
        accessorKey: "user_name",
      },
      {
        header: "Editable",
        accessorKey: "modifiable",
        muiTableBodyCellProps: {
          align: "center"
        },
        accessorFn: (d) => {
          return d.modifiable === true ? "✅" : "❌";
        },
      },
      {
        header: "Cuenta",
        accessorKey: "account",
      },
    ],
    []
  );

  const handleStateChange = (newState) => {
    const filteredRowsCount = newState.filteredRowModel
    settotal_rows(filteredRowsCount);
  };


  const update_identifiers =
    [
      { spend_folio_number: 'string' },
      { date: 'string' },
      { concept: 'string' },
      { description: 'string' },
      { ammount: 'string' },
      { user_name: 'string' },
      { modifiable: 'string' },
      { account: 'string' },
    ];

  return (
    <div >
      <MODAL_TABLE open={true} modalT={modalT}></MODAL_TABLE>

      <NotificationSystem ref={notificationSystemRef}></NotificationSystem>

      <BREADCRUMBS
        niveles={[
          {
            label:
              props.expense === "EXTRANJERO"
                ? "GASTOS DEL " + props.expense
                : "GASTOS " + props.expense,
            path: null,
          },
        ]}
        cards_dashboard={true}
        total_rows={total_rows !== "" ? total_rows : 0}
        filter_row={total_rows !== "" ? total_rows?.getFilteredRowModel()?.rows?.length : 0}
        visibility_row={total_rows !== "" ? total_rows?.getPaginationRowModel()?.rows?.length : 0}
        total={data?.length}
      ></BREADCRUMBS>



      <div className="new_table_v2">
        <div style={{ overflowX: "auto" }}>

          <MaterialReactTable
            columns={columns}
            data={data}
            enableGrouping
            enableFacetedValues
            enableStickyHeader
            enableStickyFooter
            enableRowPinning
            enableColumnFilterModes
            onStateChange={handleStateChange}
            enableRowSelection
            getRowId={(row) => row?.id}
            onRowSelectionChange={setRowSelection}
            enableTooltips={false}
            localization={MRT_Localization_ES}
            state={{ rowSelection, isLoading: isLoading }}
            enableColumnResizing
            enableColumnPinning
            enableColumnOrdering
            enableExpandAll={false}
            enableColumnDragging={false}
            initialState={{ showGlobalFilter: true, showColumnFilters: true }}
            muiCircularProgressProps={{ color: 'secondary', thickness: 5, size: 55 }}
            muiSkeletonProps={{ animation: 'pulse', height: 28 }}
            rowVirtualizerInstanceRef
            rowVirtualizerOptions={{ overscan: 5 }}
            columnVirtualizerOptions={{ overscan: 2 }}
            muiTableContainerProps={{ sx: { maxHeight: '69vh', '@media (max-height: 810px)': { maxHeight: '65vh' } } }}
            positionToolbarAlertBanner="bottom"
            paginationDisplayMode='pages'
            rowPinningDisplayMode='sticky'
            layoutMode="grid"
            muiTableHeadCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
            muiTableBodyCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
            muiPaginationProps={{ color: 'primary', shape: 'rounded', variant: 'variant', }}
            displayColumnDefOptions={{
              'mrt-row-pin': {
                Header: () => (
                  <div>
                    <img
                      title="Registrar Gasto"
                      src={CREATE}
                      className=""
                      onClick={async () => {
                        const result = await CustomDialog(
                          <CREATE_UPDATE_EXPENSE
                            codCocept={""}
                            codDescripcion={""}
                            codDate={""}
                            codImporte={0}
                            codAccount={"9090909090909"}
                            codIdPayment={""}
                            id_expense={""}
                            codidConcept={""}
                            method={"CREATE"}
                            foreing={props?.foreing}
                            origin={props?.origin}
                            handleSubmit={handleSubmit}
                          />,
                          {
                            className: "custom-modal",
                            title: "Registrar Gasto",
                            showCloseIcon: true,
                            isCanClose: false,
                          }
                        );
                      }}
                    ></img>
                  </div>
                ),
                enableHiding: true,
              },
              'mrt-row-actions': {
                enableHiding: true,
              },
              'mrt-row-expand': {
                enableHiding: true,
              },
              'mrt-row-select': {
                enableHiding: true,
              }
            }}
            muiTableBodyRowDragHandleProps={({ table }) => ({
              onDragEnd: () => {
                const { draggingRow, hoveredRow } = table.getState();
                if (hoveredRow && draggingRow) {
                  data.splice(
                    hoveredRow.index,
                    0,
                    data.splice(draggingRow.index, 1)[0],
                  );
                  setData([...data]);
                }
              },
            })}
            muiTableBodyRowProps={
              ({ row, table }) => {
                settotal_rows(table)
                const { density } = table.getState();
                return {
                  sx: {
                    height: row.getIsPinned()
                      ? `${density === 'compact' ? 30 : density === 'comfortable' ? 35 : 69
                      }px`
                      : undefined,
                  },
                };
              }
            }
            renderTopToolbarCustomActions={({ }) => (
              <Box sx={{ display: 'flex', gap: '5px', p: '2px', zIndex: "10", alignItems: 'flex-start' }}>
                <SEARCH_FILTERS
                  ff={ff}
                  setff={setff}
                  fi={fi}
                  setfi={setfi}
                  handle_get_sales={handleSubmit}
                ></SEARCH_FILTERS>

              </Box>

            )}

            renderToolbarInternalActions={({ table }) => (
              <RENDER_TOOLBAR_INTERNAL_ACTIONS
                table={table}
                file_name={props.expense === "EXTRANJERO"
                  ? "GASTOS DEL " + props.expense
                  : "GASTOS " + props.expense}
                update_identifiers={update_identifiers}
                settotal_rows={settotal_rows}
              />
            )}
            renderDetailPanel={({ row }) => {
              return (
                <EXPENSE_DETAIL
                  verData={true}
                  row={row}
                  foreign={props.foreing}
                  alertas={alertas}
                  handleSubmit={handleSubmit}
                  setmodalT={setmodalT}
                />
              )
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EXPENSES_V2;
